import AccessoriesList from './AccessoriesList';

export default AccessoriesList;
